import Button from "./Button";
import {ButtonAccent} from "./interfaces";

export default Button;
export {ButtonAccent};
